import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { Button, Form, Input } from "antd";
import "../index.css";
import { useAuth } from "../../../context/AuthContext";
import toast from 'react-hot-toast';
const LoginPage = () => {
  const { reInitAuth, loadUserFaiture } = useAuth();
  const auth = getAuth();
  const onFinish = (values) => {
    reInitAuth();
    const { password, username } = values;
    signInWithEmailAndPassword(auth, username, password).catch((error) => {
      toast.error(error.message)
      loadUserFaiture();
    });
  };

  return (
    <div className="login-container">
      <div className="login-form">
        <h1>Your Space</h1>
        <Form
          name="basic"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          initialValues={{}}
          onFinish={onFinish}
          autoComplete="off"
        >
          <Form.Item
            label="Username"
            name="username"
            rules={[{ required: true, message: "Please input your username!" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: "Please input your password!" }]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <Button type="primary" size="large" htmlType="submit">
              Login
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};
export default LoginPage;
